export const roleTypes = {
  SUPER_ADMIN: "Super Admin",
  ADMIN: "Admin",
  WAREHOUSE: "Warehouse",
  SUPPLIER: "Supplier",
  PURCHASING: "Purchasing",
};

